import {
    EuiButton,
    EuiFieldText,
    EuiFlexGroup,
    EuiFlexItem,
    EuiModal,
    EuiModalBody,
    EuiModalHeader,
    EuiModalHeaderTitle,
    EuiSpacer,
    EuiText,
    EuiTextArea,
} from "@elastic/eui";
import React from "react";

import { useAddShopGroupMutation } from "../../api/react-query/queries/admin-page";

interface AddShopGroupModalProps {
    showModal: boolean;
    setShowModal: (show: boolean) => void;
}

//TODO: Viggo Add toasts for successfull and failed requests

const AddShopGroupModal = ({ showModal, setShowModal }: AddShopGroupModalProps) => {
    const [shopGroupName, setShopGroupName] = React.useState("");
    const [shopIds, setShopIds] = React.useState("");
    const { mutateAsync: addShopGroup } = useAddShopGroupMutation();

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setShopGroupName(e.target.value);
    };

    const handleSubmit = async () => {
        try {
            await addShopGroup({
                name: shopGroupName,
                shop_ids: shopIds ? shopIds.split(",") : [],
            });
            // Close the modal after successful mutation
            setShowModal(false);
        } catch (error) {
            alert(error.message || "An error occurred");
        }
    };

    return (
        <div>
            {showModal && (
                <EuiModal onClose={() => setShowModal(false)}>
                    <EuiModalHeader>
                        <EuiModalHeaderTitle>Shop Group Toevoegen</EuiModalHeaderTitle>
                    </EuiModalHeader>
                    <EuiModalBody>
                        <EuiText>Name *</EuiText>
                        <EuiFieldText
                            placeholder="Enter Shop Group name"
                            value={shopGroupName}
                            onChange={(e) => onChange(e)}
                        />
                        <EuiSpacer />
                        <EuiText>Shop ID's</EuiText>
                        <EuiTextArea
                            placeholder="Enter shop id's. Example: ddd70853-5e9d-45ff-82b3-24c9d81d4e32,bbc0cfa7-e230-4338-817a-55190debdac0"
                            value={shopIds}
                            onChange={(e) => setShopIds(e.target.value)}
                        ></EuiTextArea>
                        <EuiSpacer />
                        <EuiFlexGroup>
                            <EuiFlexItem>
                                <EuiButton onClick={handleSubmit} fill style={{ margin: "10px" }}>
                                    Submit
                                </EuiButton>
                            </EuiFlexItem>
                            <EuiFlexItem>
                                <EuiButton onClick={() => setShowModal(false)} style={{ margin: "10px" }}>
                                    Cancel
                                </EuiButton>
                            </EuiFlexItem>
                        </EuiFlexGroup>
                    </EuiModalBody>
                </EuiModal>
            )}
        </div>
    );
};

export default AddShopGroupModal;
